<template>
<v-content style="height: 100%;" class="px-0 mx-auto">
    <v-row style="max-width: 600px; margin: 0 auto;" >
        <v-col id="base" md="12" style="height: 100%; display: flex; flex-direction: column; " class="mt-0 pt-0" >
            <!-- Header -->
            <v-row justify="center" align="center" :style="{ 'background-color': $store.state.colors.primary }" class="pb-3">
                <v-img max-width="230px" height="80px" contain :src="$store.state.logoSRC"></v-img>
            </v-row>
            <v-row justify="center" class="sticky" align="start" style="background-color: white; border-bottom: 3px solid #E8E8E8; max-height: 80px">
                <v-col class="ml-4 mt-0 pt-1 RestoRegular">
                    <v-row style="font-size: 18px; color: #4D4D4D; max-width: 300px" class="pt-2">
                        Necesitamos que nos compartas algunos datos
                    </v-row>
                    <!-- ##### ALERTA FALTA DE CAMPO ##### --> 
                    <!-- <v-snackbar v-model="alert" class="font" :top="true" color="warning">
                        ¡Falta llenar algún campo!
                    </v-snackbar>
                    <v-snackbar v-model="alert2" class="font" :top="true" color="error">
                        Los correos no coinciden
                    </v-snackbar>
                    <v-snackbar v-model="alert3" class="font" :top="true" color="error">
                        Correo no válido
                    </v-snackbar>
                    <v-snackbar v-model="alert4" class="font" :top="true" color="error">
                        Fecha de nacimiento no válida
                    </v-snackbar> -->
                </v-col>
            </v-row>

            <!-- New content -->
            <v-row style=" " class="py-0 my-0" >
                <v-col style="" class="py-0 my-0">
                    <v-row style="max-width: 350px; margin: 0 auto;">
                        <v-text-field v-model="step1.name" id="nombre" :rules="[rules.required]" label="Nombre " outlined class="mt-1 mb-2" hide-details='true'></v-text-field>
                    </v-row>
                    <v-row style="max-width: 350px; margin: 0 auto;">
                        <v-text-field v-model="step1.lastName" id="apellido" :rules="[rules.required]" label="Apellido(s)" outlined class="mt-1 mb-2" hide-details='true'></v-text-field>
                    </v-row>
                    <v-row style="max-width: 350px; margin: 0 auto;">
                        <v-text-field hint="AAAA-MM-DD" v-model="step1.birthday" :rules="[rules.required]" label="Fecha de nacimiento" id="birthday" outlined class="mt-1 mb-0"></v-text-field>
                    </v-row>
                    <!-- <v-row style="max-width: 350px; margin: 0 auto;">
                        <v-menu
                            v-model="datepickerOpen"
                            :close-on-content-click="false"
                            :nudge-right="40"
                            transition="scale-transition"
                            offset-y
                            min-width="290px">
                            <template v-slot:activator="{ on }">
                                <v-text-field
                                    v-model="step1.birthday"
                                    label="Fecha de Nacimiento"
                                    outlined
                                    hide-details="true"
                                    id="birthday"
                                    type="tel"
                                    v-on="on">
                                </v-text-field> -->
                                <!-- readonly -->
                            <!-- </template>
                            <v-date-picker v-model="step1.birthday" 
                                @input="datepickerOpen = false" 
                                locale="es-mx" 
                                :header-color="$store.state.colors.primary"
                            ></v-date-picker> -->
                            <!-- min="1965-01-01" !--> 
                        <!-- </v-menu>
                    </v-row>  -->
                    <div class="form-group" align="center" >
                        <label for="masculino">
                        <input
                            type="radio"
                            id="masculino"
                            value="M"
                            v-model="step1.gender"> Masculino
                        </label>
                        <label for="femenino">
                        <input
                            type="radio"
                            id="femenino"
                            value="F"
                            v-model="step1.gender"> Femenino
                        </label>
                    </div>
                    <v-row style="max-width: 350px; margin: 0 auto;">
                        <v-text-field v-model="step1.phone" :rules="[rules.required]" label="Teléfono" id="phone" outlined class="mt-1 mb-2" hide-details='true'></v-text-field>
                    </v-row>
                    <v-form ref="form" v-model="valid" :lazy-validation="lazy">
                        <v-row style="max-width: 350px; margin: 0 auto;">
                            <v-text-field v-model="step1.email" id="correo" label="Correo Electrónico" :rules="[rules.email,rules.required]" outlined class="mt-1 mb-2" hide-details='true'></v-text-field>
                        </v-row>
                        <!-- {{valid}} -->
                        <v-row style="max-width: 350px; margin: 0 auto;">
                            <v-text-field v-model="confirmEmail" id="correoc" label="Confirma Correo Electrónico"  :rules="[rules.equals, rules.required]" outlined class="mt-1 mb-2" hide-details='true'></v-text-field>
                        </v-row>
                    </v-form>
            </v-col>
        </v-row>

        <v-row justify="center" class="mt-2" style="max-height: 70px; margin: 0 auto; width: 100%"  >
            <v-btn @click="goTo()" class="text-left buttonLower" :color="$store.state.colors.primary" dark x-large style="width: 94%; height: 55px;  ">
                <span style="float: left; padding-left:0px;">Continuar</span>
                <v-spacer></v-spacer>
                <v-img max-width="20px" src="@/assets/resources/yoomi/arrow_white.png"></v-img>
            </v-btn>
        </v-row>
        <v-row justify="center" class="mt-4" style="max-height: 70px; margin: 0 auto; width: 100%" >
            <v-btn @click="$router.push({ name: 'verification'})" class="text-left buttonLower" :color="$store.state.colors.primary" dark x-large style="width: 94%; height: 55px; ">
                <span style="float: left; padding-left:0px;">Regresar</span>
                <v-spacer></v-spacer>
            </v-btn>
        </v-row>

        <!-- Button Continue -->
            <!-- <v-row justify="center" style="height: 15%; width: 100%; margin: 0 auto" class="pr-7 pl-0 pb-0">
                <v-btn @click="goTo()" class="text-left buttonLower" :color="$store.state.colors.primary" dark x-large style="width: 94%; height: 55px; margin: 15px; ">
                    <span style="float: left; padding-left:0px;">Continuar</span>
                    <v-spacer></v-spacer>
                    <v-img max-width="20px" src="@/assets/resources/yoomi/arrow_white.png"></v-img>
                </v-btn>
            </v-row>
                    <v-row justify="center" style="height: 15%" class="pr-7 pl-0 pt-0"> 
                        <v-btn @click="$router.push({ name: 'verification'})" absolute class="text-left buttonLower" :color="$store.state.colors.primary" dark x-large style="width: 94%; height: 55px; margin: 15px; ">
                            <span style="float: left; padding-left:0px;">Regresar</span>
                            <v-spacer></v-spacer>
                        </v-btn>
                    </v-row>
                </v-col>
            </v-row> -->


        <!-- <v-row justify="center" align="center" style="width: 100%; position: absolute; left: 0px; bottom: -10px; margin: 0 auto" class="pt-0">
            <br><br><br>
            
        </v-row> -->
            <!-- $router.push({ name: 'ubication'}); 

            <v-row justify="center" style="max-height: 70px; margin: 0 auto; width: 100%" >
                <v-btn @click="goTo()" class="text-left buttonLower" :color="$store.state.colors.primary" dark x-large style="width: 94%; height: 55px;  ">
                    <span style="float: left; padding-left:0px;">Continuar</span>
                    <v-spacer></v-spacer>
                    <v-img max-width="20px" src="@/assets/resources/yoomi/arrow_white.png"></v-img>
                </v-btn>
            </v-row>
            <v-row justify="center" style="max-height: 70px; margin: 0 auto; width: 100%" class="mt-2">
                <v-btn @click="$router.push({ name: 'verification'})" class="text-left buttonLower" :color="$store.state.colors.primary" dark x-large style="width: 94%; height: 55px; ">
                    <span style="float: left; padding-left:0px;">Regresar</span>
                    <v-spacer></v-spacer>
                </v-btn>
            </v-row>
            
            -->

        </v-col>
    </v-row>
</v-content>
</template>

<script>
// import axios from 'axios';
// import $ from 'jquery';
import Inputmask from 'inputmask';
// require ('jquery-mask-plugin');
// import { email } from 'vuelidate/lib/validators'

export default {
    data() {
        return {
            alert: false,
            alert2:false,
            alert3: false,
            alert4: false,
            valid: true,
            valid2: false,
            lazy: false,
            confirmEmail: null,
            // confirmpassword: null,
            // showPass: false,
            // showPass2: false,
            datepickerOpen: false,
            emailPattern: /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
            rules:
            {
                min: v => v ? (v.length >= 5 || "Minimo 5 characters") : true,
                equals: c => c ? (c == this.step1.email || 'Los correos no coinciden') : true,
                // equalsPass: h => h ? (h == this.step1.password || 'Las coontraseñas no coinciden') : true,
                email: value => { return value ? (this.emailPattern.test(value) || 'Correo no valido') : true },
                required: value => !!value || ''
            },
            step1:
            {
                _id: '',
                name: '',
                lastName: '',
                birthday: '',
                gender: 'M',
                phone: '',
                email: '',
            },
        }
    },
    mounted() {
        var ph = document.getElementById("phone");
        var phm = new Inputmask("(99) 9999-9999",{placeholder: " "});
        phm.mask(ph);
        var bi = document.getElementById("birthday");
        var bim = new Inputmask("9999-99-99",{placeholder: " "});
        // var bim = new Inputmask({regex:"^(19|20)\\d\\d-(0[1-9]|1[012])-(0[1-9]|[12][0-9]|3[01])$",placeholder: " "});
        bim.mask(bi);
        
        // $('document').ready(function() 
        // {
        //     $("#phone").mask("(00) 0000-0000");
        //     $("#birthday").mask("0000-00-00");
        // });
    },
    methods:
    {
        async goTo()
        {
            if((!!this.step1.name && !!this.step1.lastName && !!this.step1.birthday && !!this.step1.gender && !!this.step1.phone && !! this.step1.email && !! this.confirmEmail))
            {
                if(this.step1.email == this.confirmEmail) 
                {   
                    if(this.valid == true)
                    {
                        var res = this.step1.birthday.split("-");
                        var aaaa = parseInt(res[0]); 
                        var mm = parseInt(res[1]);
                        var dd = parseInt(res[2]);
                        // console.log("FECHA: ",res);
                        if((aaaa>1900&&aaaa<2020)&&(mm>=1&&mm<=12)&&(dd>=1&&dd<=31)&&this.step1.birthday.length==10){
                            if(dd==31){
                                if(mm==1||mm==3||mm==5||mm==7||mm==8||mm==10||mm==12){
                                    this.valid2=true;
                                }
                                else{
                                    this.valid2=false;
                                }
                            }
                            else if(dd==30){
                                if(mm!=2){
                                    this.valid2=true;
                                }
                                else{
                                    this.valid2=false;
                                }
                            }
                            else if(dd==29){
                                if(mm==2){
                                    if(aaaa%4==0){
                                        this.valid2=true;
                                    }else{
                                        this.valid2=false;
                                    }
                                }
                                else{
                                    this.valid2=true;
                                }
                            }else{
                                this.valid2=true;
                            }
                            if(this.valid2){
                                this.$store.state.newUserData.codigo_marca =  this.$store.state.codigo_marca,
                                this.$store.state.newUserData.nombre =  this.step1.name,
                                this.$store.state.newUserData.apellidos = this.step1.lastName
                                this.$store.state.newUserData.correo =  this.step1.email,
                                this.$store.state.newUserData.fecha_nac =  this.step1.birthday,
                                this.$store.state.newUserData.genero =  this.step1.gender,
                                this.$store.state.newUserData.telefono =  this.step1.phone,
                                this.$router.push({ name: 'ubication'})
                                // console.log(this.$store.state.newUserData);
                            }else{
                                this.$store.state.alertState = true;
                                this.$store.state.alertMessage = "Fecha de nacimiento no válida";
                                this.$store.state.alertColor = "warning";
                                setTimeout(() => {
                                this.$store.state.alertState = false;
                                }, 4000);
                            }
                        }else{
                            this.$store.state.alertState = true;
                            this.$store.state.alertMessage = "Fecha de nacimiento no válida";
                            this.$store.state.alertColor = "warning";
                            setTimeout(() => {
                            this.$store.state.alertState = false;
                            }, 4000);
                        }
                    }
                    else
                    {
                        this.$store.state.alertState = true;
                        this.$store.state.alertMessage = "Correo no válido";
                        this.$store.state.alertColor = "warning";
                        setTimeout(() => {
                        this.$store.state.alertState = false;
                        }, 4000);
                    }
                }
                else
                {
                    this.$store.state.alertState = true;
                    this.$store.state.alertMessage = "Los correos no coinciden";
                    this.$store.state.alertColor = "warning";
                    setTimeout(() => {
                    this.$store.state.alertState = false;
                    }, 4000);
                }
            }
            else
            {
                this.$store.state.alertState = true;
                this.$store.state.alertMessage = "¡Falta llenar algún campo!";
                this.$store.state.alertColor = "warning";
                setTimeout(() => {
                this.$store.state.alertState = false;
                }, 4000);
            }
        },
        created() {
            this.$store.state.logo = false;
            this.$store.state.validationDelivery=false;
        },
        // createAccount()
        // {
        //     const userData =
        //     {
        //         nombre: this.step1.name,
        //         apellidos: this.step1.lastName,
        //         correo: this.step1.email,
        //         fecha_nac: this.step1.birthday,
        //         genero: this.step1.gender,
        //         telefono: this.step1.phone,
        //     }
        //     console.log(userData)
        //     var username = 'swyt1';
        //     var password = 'r3stoDirec0.y';
        //     var basicAuth = 'Basic ' + btoa(username + ':' + password);

        //     const permission = { 'Content-Type': 'application/json', 'Authorization': basicAuth}
        //     this.$store.dispatch('signup',
        //     {
        //         // codigo_marca:'1',
        //         nombre: this.step1.name,
        //         apellidos: this.step1.lastName,
        //         correo: this.step1.email,
        //         fecha_nac: this.step1.birthday,
        //         genero: this.step1.gender,
        //         telefono: this.step1.phone,
        //         headers: permission
        //     })
        //     .then(response => {
        //         console.log(response)
        //     })
        //     .catch(error =>{
        //         console.log(error)
        //     })
        // }
    },
}
</script>

<style scoped>
.disable-events 
{
    pointer-events: none;
}
.font
{
    font-size: 16px;
}
div.sticky {
        position: -webkit-sticky;
        position: sticky;
        top: -1px;
        z-index: 1;
    }
</style>